import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectFiltersValue } from "app/pages/sales-intelligence/modules/leads-search-filters/store/selectors";

import type { AppsFlowStrategy } from "../context/AppsFlowContext.types";

export const useAppsFlowStrategyFromFilters = (): AppsFlowStrategy => {
    const filtersValue = useSelector(selectFiltersValue);
    const market = filtersValue?.appsFilters?.market;

    return useMemo<AppsFlowStrategy>(() => ({ market }), [market]);
};
